import type { CorteMoraExportFormat, CorteMoraFilters } from '@aid/shared';

export interface CorteMoraFilterState extends CorteMoraFilters {
  search: string;
}

export const EMPTY_CORTE_MORA_FILTERS: CorteMoraFilterState = {
  search: '',
};

export type { CorteMoraExportFormat, CorteMoraFilters };
